import LocationCitySearchModelBase from '../_generated/modelBases/location-city-search-model-base';

export default class LocationCitySearchModel extends LocationCitySearchModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
